import { PolicyTemplate } from '../../../../types/policies';
import { useGet } from '../../../../api';
import { httpGet } from '../../../utils';
import { TEMPLATES_BASE_URL } from '../consts';

const getUrl = (templateId: PolicyTemplate['id']) => `${TEMPLATES_BASE_URL}/${templateId}`;

export const getPolicyTemplateById = async (templateId: PolicyTemplate['id']): Promise<PolicyTemplate> => {
    const { data } = await httpGet(getUrl(templateId));

    // we need as here because httpGet has no typescript support
    return data as unknown as PolicyTemplate;
};

export const useGetPolicyTemplate = (templateId: PolicyTemplate['id']) => {
    const { data: template, error, loading, fetchData } = useGet<PolicyTemplate>({ url: getUrl(templateId) });

    return {
        error,
        loading,
        template,
        getPolicyTemplateById: fetchData
    };
};
